import React from "react";
import PropTypes from 'prop-types';
import ProfileButtons from "../../base/ProfileButtons";

export default class RegisteredStep extends React.PureComponent
{
    static propTypes = {
        language: PropTypes.string.isRequired,
        customerName: PropTypes.string.isRequired,
		positionId: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
	};

    render() {
        return (
            <div className="row">
                <div className="col-12">
                    <h3 className={'col-12 padding-bottom-30'}>{window.Translator.getSlug(this.props.positionId ? 'JobApplicationWasSuccessful' :'ThanksForYourInterest' , this.props.language)}</h3>
					<div className="padding-left-15">
						<h4>{sessionStorage.getItem('userName-'+this.props.customerName)}</h4>
						<div className={'margin-bottom-30'}>
							<i className={'fa fa-at'} /> {sessionStorage.getItem('email-'+this.props.customerName)} <br/>
							<i className={'fa fa-phone-square'} /> { sessionStorage.getItem('phone-'+this.props.customerName)} <br/>
						</div>
					</div>
                    <div className={'col-12 padding-bottom-40'}>
                        <p>{window.Translator.getSlug(this.props.positionId ? 'YouAppliedSuccesfully' : 'ThanksForYourInterest' , this.props.language)}. {window.Translator.getSlug('YouCanAddFiles', this.props.language)}</p>
                    </div>
                    <ProfileButtons
                        language={this.props.language}
                        customerName={this.props.customerName}
						positionId={this.props.positionId}
                    />
                </div>
            </div>
        );
    }
}



